<dx-popup
  #impersonatePopup
  class="popup"
  minWidth="300px"
  width="360px"
  height="auto"
  [showTitle]="true"
  title="Impersonate"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [(visible)]="impersonateVisible"
  (onHiding)="onCancelClick()"
  (onShown)="repaint()"
>
  <div *dxTemplate="let data of 'content'">
    <dx-validation-group #validatorImpersonate>
      <dx-box class="impersonate-container" direction="col" width="100%">
        <dxi-item baseSize="auto" class="impersonate-dxi-item">
          <div>
            Please enter an Account Number or User ID
            <sup class="cc-text-required">*</sup>
          </div>
        </dxi-item>
        <dxi-item baseSize="auto" class="impersonate-dxi-item">
          <dx-select-box
            id="selectAccountNumberOrUserId"
            [dataSource]="impersonateHistory"
            [acceptCustomValue]="true"
            displayExpr="userName"
            valueExpr="userName"
            [(value)]="impersonateParameter.userName"
            [showDropDownButton]="false"
            (onValueChanged)="onImpersonateInputChange($event)"
            (onPaste)="addNewImpersonateUser($event)"
            (onCustomItemCreating)="addNewImpersonateUser($event)"
          ></dx-select-box>
        </dxi-item>
        <dxi-item baseSize="auto">
          <dx-box
            direction="row"
            width="100%"
            class="impersonate-buttons-container"
            align="end"
            crossAlign="center"
          >
            <dxi-item [ratio]="1">
              <dx-button
                type="default"
                [icon]="cancelIcon"
                [width]="100"
                text="Cancel"
                (onClick)="hide()"
              ></dx-button>
            </dxi-item>
            <dxi-item baseSize="auto">
              <dx-button
                [icon]="saveIcon"
                type="success"
                [disabled]="isImpersonateDisabled"
                [width]="100"
                text="Apply"
                (onClick)="onImpersonateClick()"
              ></dx-button>
            </dxi-item>
          </dx-box>
        </dxi-item>
      </dx-box>
    </dx-validation-group>
  </div>
</dx-popup>

<dx-load-panel
  #loadImpersonatePassword
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#popupImpersonate' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>
